import * as Yup from "yup";

export const purposeSchema = Yup.object({
    purpose: Yup.string().required(" Enter Purpose"),
    status: Yup.string().required("Select Status"),
    type: Yup.string().required("Select Type"),
});


